{
  "version": 1,
  "asset_id": "9a5c0fc8-f6ee-46be-9aa1-571aa00c2c42",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/9a5c0fc8-f6ee-46be-9aa1-571aa00c2c42/buratti-logo.svg",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/9a5c0fc8-f6ee-46be-9aa1-571aa00c2c42/buratti-logo.svg",
  "original_filename": "buratti-logo.svg",
  "size": 6631,
  "content_type": "image/svg+xml",
  "created_at": "2026-10-08T11:31:07Z"
}
